import React from 'react';
import { Placeholder } from 'rsuite';
import { CARD_WIDTH_PIXELS } from '@/card/card-viewer/card-viewer-styles';
import styled from 'styled-components';

const NUM_ROWS_ON_CARD = 5;
const HIDE_ROWS = 0;
const CARD_COVER_IMAGE_HEIGHT = '172px';

const PropertyCardSkeltonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  .rs-placeholder-paragraph-graph-image {
    height: ${CARD_COVER_IMAGE_HEIGHT};
    width: ${CARD_WIDTH_PIXELS};
  }
`;

export function PropertyCardSkeleton() {
  return (
    <PropertyCardSkeltonWrapper>
      <Placeholder.Paragraph graph="image" rows={HIDE_ROWS} active />
      <Placeholder.Paragraph
        style={{ width: 308 }}
        rows={NUM_ROWS_ON_CARD}
        active
      />
    </PropertyCardSkeltonWrapper>
  );
}
